import create from "./create";
import manage from "./manage";

const pbs = {
	create: create,
	manage: manage,
	title: "Proxmox Backup Server",
};

export default pbs;
